// API
import api from 'app/shared/utils/api';

export const setComscore = () => {
    // @ts-ignore
    return (dispatch) =>
        dispatch(api.analytics.comscore()).catch((err: Error) => console.log('could not ping comscore', err));
};
